import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FC, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { getBase64Screenshot } from 'utils/utils';
import { submitScreenshots } from 'services/user';

const FailPage: FC = () => {
  const message = sessionStorage.getItem('errMessage');
  const { t } = useTranslation();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setTimeout(async () => {
      const screenshotParamsStr = sessionStorage.getItem('bookFail');

      if (screenshotParamsStr) {
        const screenshotParams = JSON.parse(screenshotParamsStr);
        const { transactionId, orderId, url } = screenshotParams;
        const image = await getBase64Screenshot(ref.current);

        const result = await submitScreenshots(
          { screenshots: [], orderId, lastScreenshot: image, transactionId },
          url
        );

        if (result) {
          sessionStorage.removeItem('bookFail');
        }
      }
    }, 1000);
  }, []);

  return (
    <div ref={ref} className="fail-page-wr">
      <div className="text-lg mt-30 w100p text-center">{t('payment_error')}</div>
      <p className="text-lg color-danger mt-30 w100p text-center">
        <FontAwesomeIcon icon={faCircleExclamation} className="ph-10" />
        {message}
      </p>
    </div>
  );
};

export default FailPage;
